export default __webpack_public_path__ + "static/media/video-camera.44b9f105.svg";